import script from "./TressResponsivePicture.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressResponsivePicture.vue?vue&type=script&lang=ts&setup=true"

import "./TressResponsivePicture.vue?vue&type=style&index=0&id=499af9b9&lang=scss"

const __exports__ = script;

export default __exports__